import * as React from 'react'

import { get } from 'lodash'

import {
  getFlattenLocation,
  parseLocation
} from '../../../common/utils/urlHelper'
import AlertsStreamContainer from '../../components/alerts/alertsStreamContainer'
import AutoSuggest from '../../components/autosuggest/autosuggest'
import createAutoSuggestDataContainer from '../../components/autosuggest/autoSuggestDataContainer'
import createAutoSuggestLogicContainer from '../../components/autosuggest/autoSuggestLogicContainer'
import SearchHeader from '../../components/searchHeader/searchHeader'
import SearchResultHeaders from '../../components/searchHeader/searchResultHeaders'
import SearchPageArticle from './content/searchPageArticle'
import SearchPageRelatedPosts from './content/searchPageRelatedPosts'
import SearchContentSection from './searchContentSection'

import * as autoSuggestStyles from '../../components/autosuggest/themes/searchpage.module.css'
import searchResultHeadersStyles from '../../components/searchHeader/themes/resultHeadersDefault'
import * as searchHeaderStyles from '../../components/searchHeader/themes/searchpage.module.css'
import * as styles from './searchPage.module.css'

import { Props } from '../../containers/searchPageContainer'
import RenderSurvey from './renderSurvey'

const AutoSuggestContainer = createAutoSuggestDataContainer(
  createAutoSuggestLogicContainer(AutoSuggest)
)

class SearchPage extends React.Component<Props> {
  public componentDidUpdate(prevProps: Props) {
    const { location, onSearchPageDidUpdate } = this.props
    onSearchPageDidUpdate(location, prevProps.user, prevProps.results)
  }

  public render() {
    const {
      user,
      location,
      results,
      loading,
      searchHeadings,
      ingestedContent,
      currentSite,
      baseUrl,
      relatedSearches,
      studioRecommendations
    } = this.props

    const didYouMeanByTerms = get(results, 'suggestions')
    const authorSuggestion = get(results, 'matching_author')
    const flattenLocation = getFlattenLocation(location)
    const parsedLocation = parseLocation(location)
    const seoMeta = {
      heading: searchHeadings.heading,
      subHeading: searchHeadings.sub_heading,
      finePrint: searchHeadings.fine_print
    }

    return (
      <div className="canvas_body">
        {loading ? <div className="loading-cover" /> : null}
        <div className={styles.searchHeaderSection}>
          <SearchHeader currentSite={currentSite} styles={searchHeaderStyles}>
            <AutoSuggestContainer
              inputName="term"
              value={parsedLocation.term}
              placeholder="Search within these results"
              currentSite={currentSite}
              location={location}
              styles={autoSuggestStyles}
            />
            <SearchResultHeaders
              location={location}
              totalHits={results.total_hits}
              didYouMeanByTerms={didYouMeanByTerms}
              authorSuggestion={authorSuggestion}
              seoMeta={seoMeta}
              styles={searchResultHeadersStyles}
              TagName="h1"
            />
          </SearchHeader>
        </div>
        <RenderSurvey location={location} currentSite={currentSite} />
        <AlertsStreamContainer />
        <div className="content-main--basic">
          <div className="faceted-search">
            <SearchContentSection
              user={user}
              baseUrl={baseUrl}
              results={results}
              location={location}
              loading={loading}
              currentSite={currentSite}
              relatedSearches={relatedSearches}
              studioRecommendations={studioRecommendations}
            />
          </div>

          {ingestedContent && (
            <div className="search-page-content">
              {!!ingestedContent.article && (
                <SearchPageArticle html={ingestedContent.article} />
              )}
              {ingestedContent.related_posts &&
                ingestedContent.related_posts.length === 3 && (
                  <SearchPageRelatedPosts
                    posts={ingestedContent.related_posts}
                  />
                )}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default SearchPage



// WEBPACK FOOTER //
// ./client/pages/search/searchPage.tsx